import { useAnalytics } from '@app/features/analytics/hooks/use-analytics';
import { ClearIcon } from '@app/features/analytics/icons/clear';
import { SearchIcon } from '@app/features/analytics/icons/search';
import { getTitleCase } from '@app/features/analytics/utils';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { useAnalyticsContext } from '../../providers/analytics-provider';
import { OutlineOnFocus } from '../../styles';

const SEARCH_DEBOUNCE_MS = 500;

export const SearchEvents = () => {
  const { t } = useTranslation();
  const { state, dispatch: analyticsDispatch } = useAnalyticsContext();
  const { selectedTab } = state;
  const [searchString, setSearchString] = useState(state.searchText);
  const [debouncedSearchString] = useDebounce(searchString, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    setSearchString(state.searchText || '');
  }, [selectedTab, state]);
  const { track } = useAnalytics();
  useEffect(() => {
    const searchText = debouncedSearchString?.trim();
    analyticsDispatch({
      type: 'update search text',
      payload: {
        searchText: searchText,
      },
    });

    if (searchText) {
      track('ola_search_text', {
        searchText: searchText,
        tab: getTitleCase(selectedTab),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchString]);

  const handleChange = (event: { target: { value: string } }) => {
    setSearchString(event.target.value);
  };

  const handleClear = () => {
    setSearchString('');
  };

  return (
    <div className="relative w-full">
      <span className="absolute left-2 top-[9px]">
        <SearchIcon />
      </span>

      <input
        type="text"
        value={searchString}
        onChange={handleChange}
        name={'search'}
        placeholder={t('analytics.search')}
        className={
          'px-9 py-1 h-10 w-40 border-neutral-b4 rounded-lg focus:border-blue-500' +
          OutlineOnFocus
        }
      />

      {searchString && (
        <button
          className="absolute right-2 top-[9px] hover:text-gray-600"
          onClick={handleClear}
          title="Clear"
          data-testid="clear-search"
        >
          <ClearIcon />
        </button>
      )}
    </div>
  );
};
